// src/pages/CallbackPage.jsx
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useCognitoSaml } from 'modules/auth/hooks/useCognitoSaml';

const CallbackPage = () => {
  const history = useHistory();
  const { handleCallback, loading, error } = useCognitoSaml();

  useEffect(() => {
    const processCallback = async () => {
      console.log('[SAML] CognitoSamlCallback: processCallback started', {
        currentPath: window.location.hash,
      });

      try {
        await handleCallback();

        const storedReturnUrl = sessionStorage.getItem('saml_return_url');
        const redirectTo = storedReturnUrl || '/';

        console.log('[SAML] CognitoSamlCallback: auth success, redirecting', {
          storedReturnUrl,
          redirectTo,
        });

        // Full reload so CustomAuthContext re-initializes and picks up cognito tokens.
        // Setting window.location.href with only a hash change does NOT reload on HashRouter,
        // so we set the hash and then call reload() explicitly.
        const hash = storedReturnUrl ? `#${storedReturnUrl}` : '#/';
        sessionStorage.removeItem('saml_return_url');
        window.location.hash = hash;
        window.location.reload();
      } catch (err) {
        /* eslint-disable-next-line no-console */
        console.error('[SAML] CognitoSamlCallback: processCallback failed', {
          error: err?.message,
          redirectingTo: '/login?error=auth_failed',
        });
        history.push('/login?error=auth_failed');
      }
    };

    processCallback();
  }, [handleCallback, history]);

  if (error) {
    return (
      <div className="text-center mt-5">
        <h3>Error de Autenticación</h3>
        <p>{error}</p>
        <button
          type="button"
          onClick={() => history.push('/login')}
          className="btn btn-primary"
        >
          Volver al Login
        </button>
      </div>
    );
  }

  return (
    <div className="text-center mt-5">
      <div className="spinner-border" role="status">
        <span className="sr-only">Procesando autenticación...</span>
      </div>
      <p className="mt-3">Iniciando sesión...</p>
    </div>
  );
};

export default CallbackPage;
